import type { ModuleManifest } from '../types.js'

/**
 * 1С ERP — харилцагч, бараа, агуулах, захиалга.
 *
 * Эх систем (cloud.maximus.mn) дээрх `coresoft/crm/customers`,
 * `coresoft/catalog/products`, `coresoft/warehouse/list`, `coresoft/sales/orders`
 * дэлгэцүүдийн эквивалент.
 *
 * ! ЭНЭ МОДУЛЬД ӨӨРИЙН ӨГӨГДӨЛ БАЙХГҮЙ. Дөрвүүлээ 1С-ийн MSSQL-д амьдарна;
 * ! бид Bridge-ээр (`prisma-bridge-erp`) уншиж харуулна. Prisma модель ч,
 * ! миграци ч байхгүй нь ЗОРИУД — хуулбарлавал хоёр тал зөрөх нь цаг хугацааны
 * ! асуудал бөгөөд 1С нь ганц үнэн эх сурвалж хэвээр байх ёстой.
 *
 * ! УНШИХААР эхэлж байна. 1С руу бичих нь `externalKey`-тэй, давхардлаас
 * ! хамгаалагдсан тусдаа гэрээ шаарддаг — эх системд бэлэн мөнгөний төлбөр
 * ! давхар бичигдэж 224,800₮ хоёр удаа тоологдож байсан. Тэр гэрээг дагаж
 * ! бичих үйлдлийг дараа нэмнэ.
 *
 * ! ⚠️ НЭГ ЛАВЛАХ ХҮСНЭГТ ГАРЦААР НЭМЭГДЭВ: `erp_loan_approvals` (v1.3.0).
 * ! Тэр нь 1С-ийн өгөгдлийг ХУУЛБАРЛАХГҮЙ — зөвхөн «хэн, хэзээ, ямар
 * ! төрлөөр баталсан» гэдгийг л хадгална, учир нь 1С талд тэр хариу
 * ! ХООСОН үлдэнэ (docs/20 §10.4). Захиалгын дүн, төлөв, бараа бүгд
 * ! хэвээр Bridge-ээр ирнэ.
 */
export const erpModule = {
  key: 'erp',
  name: '1С ERP',
  description: 'Харилцагч, бараа, агуулах, захиалга — 1С-ээс шууд уншина.',
  version: '1.13.0',
  icon: 'DatabaseZapIcon',

  permissions: [
    { resource: 'erp.customers', action: 'list', description: '1С-ийн харилцагч харах' },
    { resource: 'erp.customers', action: 'show', description: 'Харилцагчийн дэлгэрэнгүй' },
    { resource: 'erp.products', action: 'list', description: '1С-ийн бараа харах' },
    { resource: 'erp.products', action: 'show', description: 'Барааны дэлгэрэнгүй, үлдэгдэл' },

    /*
     * ! БИЧИХ ЭРХ — уншихаас ТУСДАА. 1С руу бичих нь үйлдвэрлэлийн өгөгдлийг
     * ! өөрчилдөг тул «харах эрхтэй бүхэн засаж чадна» гэсэн байдал үүсэх ёсгүй.
     */
    {
      resource: 'erp.products',
      action: 'manage',
      description: '1С дээрх барааны идэвхийг солих',
    },
    /*
     * ! БАЙРШИЛ нь `erp.customers:show`-Д БАГТААГҮЙ. Координат нь борлуулагчийн
     * ! аппад зочлолтын зай, гео-шалгалтыг тодорхойлдог тул буруу утга нь
     * ! ажилтныг зочилсон газраасаа хол гэж тэмдэглэнэ. «Харилцагч харах
     * ! эрхтэй бүхэн газрын зургийг зөөж чадна» гэсэн байдал үүсэх ёсгүй.
     */
    {
      resource: 'erp.customers',
      action: 'manage',
      description: 'Харилцагчийн байршил засах — 1С-д БИЧНЭ',
    },
    /*
     * ! ТУСГАЙ ГЭРЭЭ. Үүсгэх нь 1С-ийн `/hs/cloudAgreement/Create` HTTP
     * ! үйлчилгээгээр (docs/42 §10) — SQL-ээр бичихгүй.
     * !
     * ! `create`, `manage` БИШ (v1.6.0): Refine-ийн үйлдлийн нэр, яг юу
     * ! хийхийг хэлнэ. Засах, хаах нь 1С дээр хэвээр — хожим `edit`/`close`
     * ! тусдаа эрхээр нэмэгдэнэ. `hr.employees:create`-тэй ижил жишиг.
     * !
     * ! 🔴 ШИНЭ ЭРХ АНХАНДАА ЗӨВХӨН системийн дүрд (super-admin `'*'`,
     * ! admin `ALL_PERMISSION_KEYS`). Бизнесийн дүрд 1С-ийн үйлчилгээ
     * ! PRODUCTION-д нийтлэгдэж, шалгагдсаны ДАРАА олгоно — байхгүй
     * ! боломжийг эрхийн матрицад амлах ёсгүй (docs/42 §6, §10.8).
     */
    { resource: 'erp.agreements', action: 'list', description: 'Харилцагчийн тусгай гэрээ харах' },
    { resource: 'erp.agreements', action: 'show', description: 'Гэрээний дэлгэрэнгүй, төлбөрийн нөхцөл' },
    { resource: 'erp.agreements', action: 'create', description: 'Тусгай гэрээ үүсгэх — 1С-д БИЧНЭ' },
    /*
     * ! ТАЙЛАН — `erp.sales:list`-ийг ДАХИН АШИГЛААГҮЙ. `/erp/payments`,
     * ! `/erp/returns` хоёр тийм замаар явсан ч энэ тайлан нь МӨРИЙН ТҮВШНИЙ
     * ! үнэ, хөнгөлөлт, хөнгөлөлтийн хувийг ил гаргадаг — борлуулалтын
     * ! жагсаалт харах эрхтэй хүн бүрд автоматаар нээгдэх ёсгүй.
     * !
     * ! 🔴 ШИНЭ ЭРХ АНХАНДАА ЗӨВХӨН super-admin-д очно. Супервайзерууд
     * ! хэрэглэх учраас `/settings/roles`-оос тэдний ролд ГАРААР олгоно —
     * ! эс бөгөөс цэс нь тэдэнд ОГТ ХАРАГДАХГҮЙ.
     */
    { resource: 'erp.reports', action: 'list', description: '1С-ийн борлуулалтын дэлгэрэнгүй тайлан' },

    /*
     * ! Ү7 (docs/31 §4t, шалгалтын №1): BI-ийн НЭГТГЭЛ л — `/erp/1c-detail/summary|series|breakdown|customers|lookups`
     * ! (`@RequireAnyPermission('erp.reports:list', 'erp.reports:aggregate')`). ЖАГСААЛТ (`GET /erp/1c-detail`), `/export`
     * ! (мөрийн үнэ, хөнгөлөлт, дүн) НЭЭГДЭХГҮЙ, цэс харагдахгүй. Ийм учраас ажилтанд Basic борлуулалтын BI-г мөнгөгүйгээр
     * ! өгөх ЦОРЫН ГАНЦ зам: мөнгө (₮), баг/ажилтны задаргаа, ажилтан/багаар шүүх нь `bi.pro:show`-гүй бол серверийн
     * ! хаалгаар (`BiTierInterceptor`) хаалттай. `erp.reports:list` нь эдгээрийг ЖАГСААЛТААР аль хэдийн харуулдаг тул
     * ! Basic ажилтны дүрд `list` БИШ, энийг олгоно.
     */
    { resource: 'erp.reports', action: 'aggregate', description: 'Борлуулалтын BI нэгтгэл (жагсаалт, мөрийн үнэгүй)' },

    /*
     * ! `manage`, `list` БИШ. Төлөвлөгөө нь борлуулалтын багийн урамшууллын
     * ! суурь болдог тул харах эрхтэй бүхэнд нээгдэх ёсгүй. Мөн энэ дэлгэц нь
     * ! мөн чанараараа ОРУУЛАХ зориулалттай — зөвхөн харах горим байхгүй.
     */
    { resource: 'erp.plans', action: 'manage', description: 'Борлуулалтын төлөвлөгөө оруулах' },

    /*
     * ! Ү7 (D7-5, docs/31 §4t): ЗӨВХӨН УНШИХ — `GET /erp/plans`, `/lookups`, `/detail` ба BI-ийн `/erp/plans/performance`.
     * ! `manage` эзэмшигч уншсаар (API-ийн `@RequireAnyPermission('erp.plans:list', 'erp.plans:manage')` — seed-ээр дүрд
     * ! хуулахгүй: захиалгат дүр seed-д хамаарахгүй). BI-ийн төлөвлөгөөний хэсэг НЭМЭЛТЭЭР `bi.pro:show` шаардана.
     * ! Засах/оруулах (`POST`, загвар) `manage` хэвээр. Админы төлөвлөгөөний дэлгэц (оруулах) `manage` хэвээр.
     */
    { resource: 'erp.plans', action: 'list', description: 'Борлуулалтын төлөвлөгөө харах (зөвхөн унших)' },
    { resource: 'erp.warehouses', action: 'list', description: 'Агуулах, үлдэгдэл харах' },
    { resource: 'erp.orders', action: 'list', description: 'Захиалга харах' },

    /*
     * ! Ү7 (docs/31 §4t): BI-ийн захиалгын НЭГТГЭЛ л — `GET /erp/orders/summary` (тоо, төлөвөөр; дүн нь `bi.pro:show`-гүй
     * ! бол `null` + `redacted`). Захиалгын жагсаалт/дэлгэрэнгүй (дүнтэй) НЭЭГДЭХГҮЙ — `erp.reports:aggregate`-тэй ижил шалтгаан.
     */
    { resource: 'erp.orders', action: 'aggregate', description: 'Захиалгын BI нэгтгэл (жагсаалтгүй)' },
    { resource: 'erp.orders', action: 'show', description: 'Захиалгын дэлгэрэнгүй, падаан хэвлэх' },

    /*
     * ! КАТАЛОГ (брэнд, ангилал) нь ЖИЖИГ лавлах — тусад нь эрх зарлав.
     * ! Барааны эрхтэй хүн бүр лавлах засах шаардлагагүй ч харах хэрэгтэй.
     */
    { resource: 'erp.catalog', action: 'list', description: 'Брэнд, ангилал харах' },

    /*
     * ! САНХҮҮГИЙН БАРИМТ — борлуулалт, төлбөр, буцаалт. Дүн харагддаг тул
     * ! захиалгын эрхээс ТУСДАА: агуулахын ажилтан төлбөрийн түүх харах
     * ! шаардлагагүй.
     */
    { resource: 'erp.sales', action: 'list', description: 'Борлуулалт, төлбөр, буцаалт харах' },
    { resource: 'erp.sales', action: 'show', description: 'Санхүүгийн баримтын дэлгэрэнгүй' },

    /*
     * ! Ү8 (docs/31 §4u, D8-10): BI-ийн ТӨЛБӨРИЙН НЭГТГЭЛ л — `GET /erp/bi/finance/payments|payments/channels` (any-of
     * ! `erp.sales:list`). `list` нь компанийн хэмжээний жагсаалтын дэлгэц нээдэг тул Менежерт (`sales-manager`) ЭНЭ. PIN-гүй.
     */
    { resource: 'erp.sales', action: 'aggregate', description: 'Төлбөрийн BI нэгтгэл (жагсаалтгүй)' },

    { resource: 'erp.routes', action: 'list', description: 'Түгээлтийн маршрут харах' },

    /*
     * ! БИЧИХ ЭРХ ТУСДАА. Маршрутын тохиргоо нь 1С-ийн
     * ! `НастройкиТорговыхПредставителей` лавлахад бичигдэх бөгөөд тэнд
     * ! агуулах хуваарилах нь тухайн борлуулагчийн МОБАЙЛ АПП дээр харагдах
     * ! бараа, үлдэгдлийг тодорхойлно. Харах эрхтэй бүхэнд нээх ёсгүй.
     */
    { resource: 'erp.routes', action: 'manage', description: 'Маршрутын тохиргоо — агуулах, бүс, IMEI' },

    /*
     * ! МАРШРУТЫН ХАРИЛЦАГЧ нь `erp.routes`-ЭЭС ТУСДАА эрх.
     * ! `erp.routes:manage` нь НЭГ борлуулагчийн агуулахыг тохируулна.
     * ! Энэ нь 1С-ийн `_Reference247`-д МАСС бичнэ — нэг Excel буулгалт
     * ! олон зуун харилцагчийн айлчлалын хуваарийг өөрчилнө. Хамрах хүрээ
     * ! нь тэс өөр тул эрхийг нь холихгүй.
     */
    { resource: 'erp.routeCustomers', action: 'list', description: 'Маршрутын харилцагч харах' },
    { resource: 'erp.routeCustomers', action: 'manage', description: 'Маршрутын харилцагч тохируулах — 1С-д БИЧНЭ' },

    /*
     * ! v1.8.0: ТӨЛБӨР ТӨЛӨХ ДАНС нь `erp.routeCustomers`-ЭЭС ТУСДАА эрх. 1С-ийн
     * ! `Справочник.Партнеры.maxCompanyBankDans`-д (харилцагч × байгууллага × гэрээт → данс) МАСС бичнэ —
     * ! буруу утга нь харилцагчийн төлбөрийг ӨӨР ДАНС руу чиглүүлнэ. Маршрутын хуваарь тохируулах эрхтэй
     * ! бүх хүнд автоматаар очих ёсгүй. Бичилт нь жишгийн (`erp.routeCustomers`) адил bridge-ийн ШУУД SQL.
     */
    { resource: 'erp.customerBankDans', action: 'list', description: 'Харилцагчийн төлбөр төлөх данс харах' },
    { resource: 'erp.customerBankDans', action: 'manage', description: 'Харилцагчийн төлбөр төлөх данс оруулах — 1С-д БИЧНЭ' },

    /*
     * ! v1.9.0: БАРААНЫ СЕРИ (docs/63 §13) — 1С-ийн НООРОГ «Реализация товаров и услуг»-ийн (`_Document358`, «По заказам»)
     * ! Товары/Серии-д ШУУД SQL-ээр бичнэ (bridge `doc-series`). Проведение нь 1С-д хэвээр (админ гараар).
     * ! ЖАГСААЛТЫН ЭРХ БАЙХГҮЙ: хуудас нь зөвхөн бичих урсгал. Seed: `admin` (ALL_PERMISSION_KEYS), `super-admin` ('*');
     * ! өөр дүрд ОЛГОХГҮЙ («1C» дүр `manage`-ийг авдаггүй). Prod-д bridge-ийн `DOC_SERIES_WRITE_ENABLED` унтраалттай.
     */
    { resource: 'erp.productSeries', action: 'manage', description: 'Барааны сери — ноорог борлуулалтад 1С-д БИЧНЭ' },

    /*
     * ! KA СҮЛЖЭЭНИЙ PO → 1С ЗАХИАЛГА (docs/64). Оруулах/тулгах нь 1С-д БИЧИХГҮЙ (`import`); холбоос (`map`) нь cloud-ийн
     * ! хүснэгт; зөвхөн `approve` 1С-д захиалга үүсгэнэ (мөн `KA_ORDERS_WRITE_ENABLED` унтраалга).
     */
    { resource: 'erp.kaOrders', action: 'list', description: 'KA сүлжээний PO харах' },
    { resource: 'erp.kaOrders', action: 'import', description: 'KA сүлжээний PO оруулах, 1С-тэй тулгах (бичихгүй)' },
    { resource: 'erp.kaOrders', action: 'map', description: 'KA PO-ийн салбар, бараа, гэрээний холбоос засах' },
    { resource: 'erp.kaOrders', action: 'approve', description: 'KA PO-оос захиалга үүсгэх — 1С-д БИЧНЭ' },

    /*
     * ! v1.10.0: B2B НЭВТРЭХ ЭРХ (2026-10-14, харилцагчийн «B2B нэвтрэх» таб) — `erp.customers:manage`-ЭЭС ТУСДАА: тэр нь
     * ! «байршил 1С-д бичих» утгатай; нэвтрэх PIN тавих = тухайн харилцагчийн нэрээр B2B-д нэвтрэх (өр, захиалга, падаан).
     * ! 1С-д БИЧИХГҮЙ — cloud-ийн `b2b_clients` (нэвтрэх нэр нь 1С-ийн `Corporate_id`, зөвхөн уншина).
     * ! Seed: `admin` (ALL_PERMISSION_KEYS), `super-admin` ('*'); «1C» дүр `list`-ийг автоматаар авна (төлөв, сүүлийн IP —
     * ! эзний шийдвэр 2026-10-14), `manage`-ийг АВАХГҮЙ. Өөр дүрд олгох бол `seed.ts`-д (гараар олгосон нь release-д буцна).
     */
    { resource: 'erp.customerB2b', action: 'list', description: 'Харилцагчийн B2B нэвтрэх эрх харах' },
    { resource: 'erp.customerB2b', action: 'manage', description: 'Харилцагчийн B2B нэвтрэх PIN үүсгэх, идэвх солих' },

    /*
     * ! МАРШРУТЫН БАРАА нь ХАРИЛЦАГЧААС ТУСДАА эрх. Хоёулаа маршруттай
     * ! холбоотой ч хамрах хүрээ нь өөр: харилцагч нь ХЭНД зочлохыг,
     * ! бараа нь ЮУ зарахыг тодорхойлно. Борлуулалтын ассортимент нь
     * ! үнийн бодлоготой шууд холбоотой тул хуваарь тохируулах эрхтэй
     * ! бүх хүнд автоматаар очих ёсгүй.
     *
     * ! 1С-д `РегистрСведений.НоменклатураСегмента`-д бичнэ. Нэг удаагийн
     * ! масс үйлдэл олон зуун бараа × олон сегментийг хөндөж, борлуулагчийн
     * ! аппад шууд нөлөөлнө.
     */
    { resource: 'erp.routeProducts', action: 'list', description: 'Маршрутын бараа харах' },
    { resource: 'erp.routeProducts', action: 'manage', description: 'Маршрутын бараа тохируулах — 1С-д БИЧНЭ' },
    { resource: 'erp.marketing', action: 'list', description: 'Урамшуулал, зочлолт харах' },

    /*
     * ЗЭЭЛ, АВЛАГА — `erp.sales`-тай ЯГ ИЖИЛ ШАЛТГААНААР ТУСДАА. Өр, лимит,
     * насжилт нь харилцагчийн төлбөрийн чадварыг ил гаргана; захиалга харах
     * эрхтэй бүх хүнд автоматаар очих ёсгүй.
     *
     * ! БИЧИХ ЭРХ ОДОО БАЙНА — `erp.credit:approve`. 2026-09-12-нд хэрэглэгч
     * ! шийдвэр гаргав: ахлах 1С-д НЭВТРЭХГҮЙ, зээлийн гэрээт захиалгыг
     * ! CLOUD дээр батална (docs/20 §10). Өөр зам ч байсангүй: гэрээнээс
     * ! зээлийн төрлийг үр тарих багана production-д БАЙХГҮЙ (`_Reference218`-д
     * ! `maxLoanType` алга) тул төрлийг ахлах хүн л сонгож чадна.
     * !
     * ! 🔴 «ХЭН БАТАЛСАН»-Ы ЭХ СУРВАЛЖ НЬ CLOUD. Bridge бүх проксиг нэг дундын
     * ! Basic auth акаунтаар хийдэг тул 1С-ийн `maxIsLoanPerson` нь сервис
     * ! акаунтаар тамгалагдах эрсдэлтэй — подписка түүнийг цагаан жагсаалтаар
     * ! хааж, талбарыг ХООСОН үлдээнэ (docs/20 §10.4). Аудит нь `erp_loan_approvals`
     * ! хүснэгтэд амьдарна.
     * !
     * ! Хоригийг гараар чөлөөлөх үйлдэл нь агуулахын дараалалд хамаарах тул
     * ! `warehouse.orders:override-payment` дээрээ үлдэнэ, энд давхардуулахгүй —
     * ! `approve` нь ТУСДАА асуулт: «зээлээр гаргах гэрээ хүчинтэй үү».
     */
    { resource: 'erp.procurement', action: 'list', description: 'Гадаад худалдан авалт, тээвэр, гаалийн жагсаалт харах' },
    { resource: 'erp.procurement', action: 'show', description: 'Захиалгын 360° дэлгэрэнгүй, өртгийн задаргаа' },
    { resource: 'erp.procurement', action: 'manage', description: 'Тээвэр, жолооч, гаалийн төлөв шинэчлэх; буулгах цаг батлах' },

    /*
     * ! АГУУЛАХЫН ОРЛОГО (v1.12.0) — машин бүрийн хүлээн авалт. `create` = агуулахын эрхлэгч (өөрийн ноорог үүсгэх,
     * ! засах, батлуулахаар илгээх); `approve` = нягтлан (батлах / буцаах). Батлагч нь үүсгэсэн, илгээсэн хүнээс
     * ! ӨӨР байх ёстой — үүнийг API-ийн сервис хатуу шалгана (эрхээр биш). Унших нь `erp.procurement:show`.
     */
    { resource: 'erp.procurement.receipt', action: 'create', description: 'Гадаад худалдан авалтын орлого (машин бүрээр) бүртгэх, батлуулахаар илгээх' },
    { resource: 'erp.procurement.receipt', action: 'approve', description: 'Гадаад худалдан авалтын орлогыг батлах / буцаах (нягтлан)' },
    { resource: 'erp.credit', action: 'list', description: 'Авлагын насжилт, зээлийн лимит, хориг харах' },
    { resource: 'erp.credit', action: 'show', description: 'Гэрээний төлбөрийн нөхцөл, падааны задаргаа' },
    { resource: 'erp.credit', action: 'approve', description: 'Зээлийн гэрээт захиалга батлах' },

    /*
     * ! Ү8 (docs/31 §4u, D8-10): BI-ийн АВЛАГА/ЛИМИТ/ХОРИГ/ЗЭЭЛИЙН НЭГТГЭЛ л — `GET /erp/bi/finance/receivables|credit|
     * ! blacklist|loans` (any-of `erp.credit:list`). `erp.reports:aggregate`-ийн Ү7 сургамж: `list` компанийн жагсаалт нээнэ.
     */
    { resource: 'erp.credit', action: 'aggregate', description: 'Авлага, лимит, хорио, зээлийн BI нэгтгэл (жагсаалтгүй)' },
  ],

  navigation: [
    /*
     * ! 1С ERP-ийн ЦЭС ДӨРВӨН БҮЛЭГТ (2026-10-11, эзний бүтэц): Лавлагаа · Баримтууд · Тайлан · Тохиргоо, дараа нь
     * ! «Зээл ба авлага». Зам, эрх, дүрс ӨӨРЧЛӨГДӨӨГҮЙ — зөвхөн байрлал. Модулийн «буух хуудас» нь эхний мөр
     * ! (`navDestinations[].landing`) тул «Харилцагч» эхэнд хэвээр.
     */
    {
      label: 'Лавлагаа',
      items: [
        {
          label: 'Харилцагч',
          href: '/erp/customers',
          icon: 'Building2Icon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'erp.customers:list',
        },
        {
          /*
           * ! ХАРИЛЦАГЧИЙН ДАРАА. Гэрээ нь харилцагчийн ШИНЖ тул цэсэнд ч
           * ! түүний хажууд байх нь эрэл хайлтыг богиносгоно.
           */
          label: 'Тусгай гэрээ',
          href: '/erp/agreements',
          icon: 'HandshakeIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'erp.agreements:list',
        },
        {
          label: 'Бараа',
          href: '/erp/products',
          icon: 'PackageIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'erp.products:list',
        },
        {
          label: 'Агуулах',
          href: '/erp/warehouses',
          icon: 'WarehouseIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'erp.warehouses:list',
        },
        {
          label: 'Брэнд',
          href: '/erp/brands',
          icon: 'TagIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'erp.catalog:list',
        },
        {
          label: 'Ангилал',
          href: '/erp/categories',
          icon: 'FolderTreeIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'erp.catalog:list',
        },
        {
          label: 'Урамшуулал',
          href: '/erp/promos',
          icon: 'PercentIcon',
          iconClassName: 'text-pink-600 dark:text-pink-400',
          permission: 'erp.marketing:list',
        },
      ],
    },

    {
      label: 'Баримтууд',
      items: [
        {
          label: 'Захиалга',
          href: '/erp/orders',
          icon: 'ShoppingCartIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'erp.orders:list',
        },
        {
          /*
           * ! v1.11.0 (docs/64): KA сүлжээний PO-г оруулж, 1С-тэй тулгаж, БАТАЛСНЫГ 1С-д захиалга болгоно. 1С-ийн
           * ! «Захиалга»-ын ДАРАА — нэг төрлийн баримт. Мөр нь `list` эрхээр; оруулах/батлах нь дэлгэц доторх эрхээр.
           */
          label: 'KA Авто захиалга',
          icon: 'FileInputIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          children: [
            { label: 'Захиалга', href: '/erp/ka-orders', permission: 'erp.kaOrders:list' },
            { label: 'Харилцагч зөв оноох', href: '/erp/ka-orders/clients', permission: 'erp.kaOrders:list' },
            { label: 'Барааны баркод тохиргоо', href: '/erp/ka-orders/barcodes', permission: 'erp.kaOrders:list' },
          ],
        },
        {
          label: 'Борлуулалт',
          href: '/erp/sales',
          icon: 'ReceiptTextIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'erp.sales:list',
        },
        {
          label: 'Төлбөр',
          href: '/erp/payments',
          icon: 'BanknoteIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'erp.sales:list',
        },
        {
          label: 'Буцаалт',
          href: '/erp/returns',
          icon: 'Undo2Icon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'erp.sales:list',
        },
      ],
    },

    {
      label: 'Тайлан',
      items: [
        {
          label: 'Зочлолт',
          href: '/erp/visitors',
          icon: 'MapPinnedIcon',
          iconClassName: 'text-pink-600 dark:text-pink-400',
          permission: 'erp.marketing:list',
        },
        /*
         * ! ҮНДСЭН МӨР, дэд цэс БИШ. Эхэндээ «ирээдүйд өөр тайлан нэмэгдэнэ»
         * ! гэж `children`-тэй бүлэг болгосон боловч задарсан мөр нь
         * ! `SidebarMenuSubButton`-ий `h-7` дотор ТАСАРЧ байв. Хоёр дахь тайлан
         * ! ирэх үед л бүлэг болгоно — `/erp/1c-detail` зам хэвээр үлдэх тул
         * ! хэрэглэгчийн хадгалсан хаяг эвдрэхгүй.
         */
        {
          label: 'Борлуулалтын тайлан',
          href: '/erp/1c-detail',
          icon: 'FileSpreadsheetIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'erp.reports:list',
        },
      ],
    },

    {
      label: 'Тохиргоо',
      items: [
        {
          label: 'Маршрут',
          href: '/erp/routes',
          icon: 'RouteIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'erp.routes:list',
        },
        {
          label: 'Маршрутын харилцагч',
          href: '/erp/marshrut-customers',
          icon: 'MapPinnedIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'erp.routeCustomers:list',
        },
        {
          /* ! v1.8.0: жишгийн адил ЖАГСААЛТ руу заана; масс оруулах нь жагсаалтын «+ Шинээр оруулах» (`/create`). */
          label: 'Төлбөр төлөх данс',
          href: '/erp/customer-bankdans',
          icon: 'LandmarkIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'erp.customerBankDans:list',
        },
        {
          label: 'Маршрутын бараа',
          href: '/erp/marshrut-product',
          icon: 'PackageSearchIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'erp.routeProducts:list',
        },
        /*
         * ! v1.11.0 (docs/64 §4a): KA PO-ийн ТУЛГАЛТЫН ТОХИРГОО — бүртгэл (сүлжээ × байгууллага: гэрээ, ХТ, агуулах),
         * ! салбар → 1С харилцагч, баркод → 1С бараа. Гурвуулаа cloud-ийн хүснэгт, 1С-д бичихгүй; харах нь `list`,
         * ! засах нь дэлгэц доторх `map` эрхээр. Шошго БОГИНО — дэд мөрөнд багтана ([[11-conventions §Сайдбарын шошго]]).
         */
        {
          label: 'KA тохиргоо',
          icon: 'StoreIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          children: [
            { label: 'Харилцагч', href: '/erp/ka-customers', permission: 'erp.kaOrders:list' },
            { label: 'Салбар', href: '/erp/ka-stores', permission: 'erp.kaOrders:list' },
            { label: 'Баркод', href: '/erp/ka-barcodes', permission: 'erp.kaOrders:list' },
          ],
        },
        /*
         * ! МАСС ҮЙЛДЭЛ — 1С-Д ОЛНООР БИЧДЭГ хуудсууд нэг дор (2026-10-11, эзний бүтэц). Жагсаалтууд дээрх мөрүүдэд
         * ! хэвээр; энд зөвхөн `/create` ба төлөвлөгөө оруулах. Мөр бүр `:manage` эрхтэй тул унших эрхтэй хүнд
         * ! (жишээ нь «1C» дүр) энэ мөр БҮХЭЛДЭЭ нуугдана (`use-visible-nav`: хүүхэдгүй болсон мөрийг хасна).
         * !
         * ! «Маршрутын бараа»-д масс оруулах хуудас ХАРААХАН БАЙХГҮЙ (сегмент тус бүрийн «бараа нэмэх» цонх л) —
         * ! хуудас хийгдмэгц энд нэмнэ. Жагсаалт руу давхар холбоос тавихгүй: идэвхтэй мөр хоёр газар асна.
         * !
         * ! «Төлөвлөгөө оруулах» нь ГУРАВДАХЬ түвшин — `navConfig` `toMenuItem` түүнийг дэд бүлэг болгоно. Шошго
         * ! БОГИНО («Харилцагчаар», «Брэндээр») тул дэд мөрөнд багтана ([[11-conventions §Сайдбарын шошго]]).
         */
        {
          label: 'Масс үйлдэл хийх',
          icon: 'LayersIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          children: [
            {
              label: 'Маршрутын харилцагч',
              href: '/erp/marshrut-customers/create',
              permission: 'erp.routeCustomers:manage',
            },
            {
              label: 'Төлбөр төлөх данс',
              href: '/erp/customer-bankdans/create',
              permission: 'erp.customerBankDans:manage',
            },
            {
              /* ! v1.9.0 (docs/63 §13): ноорог борлуулалтын серийн задаргаа — 1С-д БИЧНЭ, жагсаалтгүй. */
              label: 'Барааны сери',
              href: '/erp/product-seri',
              permission: 'erp.productSeries:manage',
            },
            {
              label: 'Төлөвлөгөө оруулах',
              permission: 'erp.plans:manage',
              children: [
                { label: 'Харилцагчаар', href: '/erp/plans/customer', permission: 'erp.plans:manage' },
                { label: 'Брэндээр', href: '/erp/plans/brand', permission: 'erp.plans:manage' },
              ],
            },
          ],
        },
      ],
    },

    /*
     * ! ХОЁРДУГААР БҮЛЭГ, ТУСДАА МОДУЛЬ БИШ. Нэг манифест олон бүлэг зарлаж
     * ! чадна (`hr` модульд ч хоёр бүлэг бий) — сайдбарт «1С ERP» ба
     * ! «Зээл ба авлага» гэсэн хоёр хэсэг болж гарна, хоёул `erp` доторх.
     * !
     * ! Тусад нь `credit` модуль болговол зээлийн тайлангаас харилцагчийн
     * ! дэлгэрэнгүй рүү очиход сайдбар бүхэлдээ солигдоно — цэс идэвхтэй
     * ! модулиар хүрээлэгддэг ([[coresoft-module-scoped-sidebar]]).
     * !
     * ! «Санхүүгийн хүнд зөвхөн зээл» гэдгийг МОДУЛИАР биш ЭРХЭЭР шийднэ:
     * ! цэсний мөр бүр `permission`-оор шүүгддэг.
     */
    {
      label: 'Гадаад худалдан авалт',
      items: [
        { label: 'Захиалгын самбар', href: '/erp/procurement', icon: 'PlaneIcon', iconClassName: 'text-sky-600 dark:text-sky-400', permission: 'erp.procurement:list' },
        { label: 'Замд яваа ачаа', href: '/erp/procurement/in-transit', icon: 'TruckIcon', iconClassName: 'text-amber-600 dark:text-amber-400', permission: 'erp.procurement:list' },
        { label: 'Гаалийн бүрдүүлэлт', href: '/erp/procurement/customs', icon: 'LandmarkIcon', iconClassName: 'text-emerald-600 dark:text-emerald-400', permission: 'erp.procurement:list' },
        { label: 'Худалдан авалтын бараа', href: '/erp/procurement/products', icon: 'PackageSearchIcon', iconClassName: 'text-violet-600 dark:text-violet-400', permission: 'erp.procurement:list' },
        /*
         * ! Цэсний `permission` нь ГАНЦ түлхүүр (any-of алга) — тиймээс хоёр мөр: батлах дараалал нягтланд,
         * ! «Миний орлого» агуулахын менежерт. API нь `receipts*`-д list/show БА (create ЭСВЭЛ approve)-г шаардана.
         */
        { label: 'Орлого батлах', href: '/erp/procurement/receipts', icon: 'ClipboardCheckIcon', iconClassName: 'text-orange-600 dark:text-orange-400', permission: 'erp.procurement.receipt:approve' },
        { label: 'Миний орлого', href: '/erp/procurement/my-receipts', icon: 'ClipboardListIcon', iconClassName: 'text-teal-600 dark:text-teal-400', permission: 'erp.procurement.receipt:create' },
      ],
    },
    {
      label: 'Зээл ба авлага',
      items: [
        {
          label: 'Авлагын насжилт',
          href: '/erp/credit',
          icon: 'CalendarClockIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'erp.credit:list',
        },
        {
          label: 'Зээлийн лимит',
          href: '/erp/credit-limits',
          icon: 'GaugeIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'erp.credit:list',
        },
        {
          label: 'Зээлийн гэрээт захиалга',
          href: '/erp/loan-orders',
          icon: 'FileSignatureIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'erp.credit:list',
        },
        {
          label: 'Хоригдсон захиалга',
          href: '/erp/credit-blocked',
          icon: 'ShieldAlertIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'erp.credit:list',
        },
        {
          label: 'Хориглосон сегмент',
          href: '/erp/credit-blacklist',
          icon: 'UserXIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'erp.credit:list',
        },
      ],
    },
  ],

  resources: [
    {
      name: 'erp.customers',
      label: 'Харилцагч',
      list: '/erp/customers',
      show: '/erp/customers/:id',
    },
    {
      name: 'erp.agreements',
      label: 'Тусгай гэрээ',
      list: '/erp/agreements',
      show: '/erp/agreements/:id',

      /*
       * ! v1.7.0: «Шинэ тусгай гэрээ» — ЦОНХ БИШ, бүтэн хуудас (docs/42 §11.8).
       * ! `?from=<гэрээ>` бол «Одоо байгаа гэрээнээс» горим. Эрх нь
       * ! `erp.agreements:create` хэвээр — шинэ эрх нэмээгүй.
       */
      create: '/erp/agreements/new',
    },
    { name: 'erp.products', label: 'Бараа', list: '/erp/products', show: '/erp/products/:id' },
    { name: 'erp.warehouses', label: 'Агуулах', list: '/erp/warehouses' },
    { name: 'erp.orders', label: 'Захиалга', list: '/erp/orders', show: '/erp/orders/:id' },

    /*
     * ! `name` нь эрхийн resource-той ЗААВАЛ тэнцүү байна — эрхийн шалгагч
     * ! `${resource}:${action}` гэж мөр залгаж шалгадаг.
     * ! Үлдсэн гурван дэлгэц resource зарлахгүй: erp-ийн 12 цэсний мөрөнд
     * ! ердөө 4 resource байгаа жишгээр тэдгээр нь шууд дуудлагаар татна.
     */
    { name: 'erp.credit', label: 'Зээлийн гэрээ', list: '/erp/credit', show: '/erp/credit/:id' },
  ],
} as const satisfies ModuleManifest
